<template>
    <div class="p-4 position-relative">
        <ValidationObserver ref="infoForm">
            <!-- Kişisel Bilgiler Section -->
            <fieldset class="border p-3 mb-4 rounded">
                <legend class="w-auto px-2 font-weight-bold h6">{{ $t('personal_information') }}</legend>
                <b-row>
                    <b-col sm="12" md="4" class="mb-3">
                        <ValidationProvider name="national_id" rules="required" v-slot="{valid, errors}">
                            <b-form-group :label="$t('tc_or_passport')">
                                <b-form-input size="sm" v-model="form.national_id" :state="errors[0] ? false : (valid ? true : null)" v-mask="'###########'"></b-form-input>
                                <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>

                    <b-col sm="12" md="4" class="mb-3">
                        <ValidationProvider name="name" rules="required" v-slot="{valid, errors}">
                            <b-form-group :label="$t('name')">
                                <b-form-input size="sm" v-model="form.name" :state="errors[0] ? false : (valid ? true : null)" @input="form.name = $event.toLocaleUpperCase('tr')" class="text-uppercase"></b-form-input>
                                <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>

                    <b-col sm="12" md="4" class="mb-3">
                        <ValidationProvider name="surname" rules="required" v-slot="{valid, errors}">
                            <b-form-group :label="$t('surname')">
                                <b-form-input size="sm" v-model="form.surname" :state="errors[0] ? false : (valid ? true : null)" @input="form.surname = $event.toLocaleUpperCase('tr')" class="text-uppercase"></b-form-input>
                                <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>

                    <b-col sm="12" md="4" class="mb-3">
                         <ValidationProvider name="gender" rules="required" v-slot="{valid, errors}">
                              <b-form-group :label="$t('gender')">
                                  <gender-selectbox v-model="form.gender" :state="errors[0] ? false : (valid ? true : null)" :validate-error="errors[0]"/>
                              </b-form-group>
                         </ValidationProvider>
                    </b-col>

<!--                    <b-col sm="12" md="4" class="mb-3">-->
<!--                         <ValidationProvider name="birthDate" rules="required" v-slot="{valid, errors}">-->
<!--                              <b-form-group :label="$t('birthdate')">-->
<!--                                  <select-date v-model="form.birthDate" :state="errors[0] ? false : (valid ? true : null)"/>-->
<!--                                  <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>-->
<!--                              </b-form-group>-->
<!--                         </ValidationProvider>-->
<!--                    </b-col>-->

                    <b-col sm="12" md="4" class="mb-3">
                         <ValidationProvider name="nationality_code" rules="required" v-slot="{valid, errors}">
                              <b-form-group :label="$t('nationality')">
                                <country-selectbox
                                    valueType="code"
                                    :public="true"
                                    :validateError="errors[0]"
                                    v-model="form.nationality_code">
                                </country-selectbox>
                              </b-form-group>
                         </ValidationProvider>
                    </b-col>

                    <b-col sm="12" md="4" class="mb-3">
                        <ValidationProvider name="mother_name" rules="required" v-slot="{valid, errors}">
                            <b-form-group :label="$t('mother_name')">
                                <b-form-input size="sm" v-model="form.mother_name" :state="errors[0] ? false : (valid ? true : null)" @input="form.mother_name = $event.toLocaleUpperCase('tr')" class="text-uppercase"></b-form-input>
                                <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>

                    <b-col sm="12" md="4" class="mb-3">
                        <ValidationProvider name="father_name" rules="required" v-slot="{valid, errors}">
                            <b-form-group :label="$t('father_name')">
                                <b-form-input size="sm" v-model="form.father_name" :state="errors[0] ? false : (valid ? true : null)" @input="form.father_name = $event.toLocaleUpperCase('tr')" class="text-uppercase"></b-form-input>
                                <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>

                    <b-col sm="12" md="4" class="mb-3">
                        <ValidationProvider name="birth_place" rules="required" v-slot="{valid, errors}">
                            <b-form-group :label="$t('birthplace')">
                                <b-form-input size="sm" v-model="form.birth_place" :state="errors[0] ? false : (valid ? true : null)" @input="form.birth_place = $event.toLocaleUpperCase('tr')" class="text-uppercase"></b-form-input>
                                <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>
                </b-row>
            </fieldset>

            <!-- İletişim Bilgileri Section -->
            <fieldset class="border p-3 mb-4 rounded">
                <legend class="w-auto px-2 font-weight-bold h6">{{ $t('contact_information') }}</legend>
                <b-row>
                    <b-col sm="12" md="4" class="mb-3">
                        <ValidationProvider name="phone" rules="required" v-slot="{valid, errors}">
                            <b-form-group :label="$t('telephone')">
                                <b-form-input size="sm" v-model="form.phone" v-mask="'(5##)-###-####'" :state="errors[0] ? false : (valid ? true : null)"></b-form-input>
                                <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>

                    <b-col sm="12" md="4" class="mb-3">
                        <ValidationProvider name="email" rules="required|email" v-slot="{valid, errors}">
                            <b-form-group :label="$t('email_address')">
                                <b-form-input size="sm" v-model="form.email" :state="errors[0] ? false : (valid ? true : null)"></b-form-input>
                                <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>

                    <!-- <div class="w-100 d-none d-md-block"></div> -->

                    <b-col sm="12" md="4" class="mb-3">
                         <ValidationProvider name="city" rules="required" v-slot="{valid, errors}">
                              <b-form-group :label="$t('city')">
                                <city-selectbox
                                        :validateError="errors[0]"
                                        v-model="form.city_id">
                                    </city-selectbox>
                              </b-form-group>
                         </ValidationProvider>
                    </b-col>

                    <b-col sm="12" md="4" class="mb-3">
                         <ValidationProvider name="district" rules="required" v-slot="{valid, errors}">
                              <b-form-group :label="$t('district')">
                                <district-outline-selectbox
                                        :city_id="form.city_id"
                                        :validateError="errors[0]"
                                        v-model="form.district_id">
                                    </district-outline-selectbox>
                              </b-form-group>
                         </ValidationProvider>
                    </b-col>

                    <b-col sm="12" class="mb-3">
                        <ValidationProvider name="address" rules="required" v-slot="{valid, errors}">
                            <b-form-group :label="$t('address_2')">
                                <b-form-textarea rows="3" v-model="form.address" :state="errors[0] ? false : (valid ? true : null)" @input="form.address = $event.toLocaleUpperCase('tr')" class="text-uppercase"></b-form-textarea>
                                <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>
                </b-row>
            </fieldset>
            <div class="d-flex justify-content-center mt-3">
                <b-button variant="primary" @click="submitAndNext" :disabled="loading" class="px-5 font-weight-bold shadow-sm">
                    <b-spinner small v-if="loading"></b-spinner>
                    <span v-else>{{ $t('next') }}</span>
                </b-button>
            </div>
        </ValidationObserver>

<!--        <b-modal ref="infoModal" hide-header hide-footer centered body-class="p-0 border rounded">-->
<!--            <div class="p-4 bg-white rounded shadow-sm text-center">-->
<!--                <div class="font-weight-bold text-success mb-3 h5">-->
<!--                    <i class="ri-information-line ri-2x align-middle mr-2"></i> {{ $t('info') }}-->
<!--                </div>-->
<!--                <p class="text-muted mb-4 font-size-14" v-html="$t('application_resume_info_text')"></p>-->
<!--                <b-button variant="primary" class="px-5" @click="$refs.infoModal?.hide()">{{ $t('ok') }}</b-button>-->
<!--            </div>-->
<!--        </b-modal>-->

    </div>
</template>

<script>
import {ValidationObserver, ValidationProvider} from "vee-validate";
import DistrictOutlineSelectbox from "@/components/interactive-fields/DistrictOutlineSelectbox.vue";
import CitySelectbox from "@/components/interactive-fields/CitySelectbox.vue";
import GenderSelectbox from "@/components/interactive-fields/GenderSelectbox.vue";
import SpecialStudentApplicationRegisterServices from "@/services/SpecialStudentApplicationRegisterServices";
import {setWithExpiry} from "@/libs/Helpers";

export default {
    name: "InfoTab",
    components: {
        ValidationObserver,
        ValidationProvider,
        CitySelectbox,
        DistrictOutlineSelectbox,
        GenderSelectbox
    },
    props: {
        initialData: {
            type: Object,
            default: () => ({})
        },
        countDown:{
            type:Number,
            default:0
        }
    },
    data() {
        return {
            form: {
                national_id: null,
                name: null,
                surname: null,
                gender: null,
                nationality_code: null,
                mother_name: null,
                father_name: null,
                birth_place: null,
                phone: null,
                email: null,
                city_id: null,
                district_id: null,
                address: null
            },
            loading: false
        }
    },
    mounted() {
        // if(!sessionStorage.getItem('special_student_info_shown')) {
        //     this.$refs.infoModal.show();
        //     sessionStorage.setItem('special_student_info_shown', 'true');
        // }
        this.form = this.getWithExpiry('specialStudentData',true)
    },
    methods: {
        async submitAndNext() {
            const isValid = await this.$refs.infoForm.validate();
            if (!isValid) {
                return;
            }
            this.loading = true;

            let payload = {
                ...this.form,
                phone: this.form.phone ? this.form.phone.replace(/\D/g, '') : null,
            };

            SpecialStudentApplicationRegisterServices.updateInformation(payload).then(response => {
                this.loading = false;
                this. setWithExpiry('specialStudentData',response.data.data,this.countDown,true)
                this.$toast.success(this.$t("proccess_success"));
                this.$emit('next', 1);
            }).catch(e => {
                this.loading = false;
                this.showErrors(e,this.$refs.infoForm)
            });
        }
    }
}
</script>
